import { render, staticRenderFns } from "./DeleteServer.vue?vue&type=template&id=16efcba6&scoped=true"
import script from "./DeleteServer.vue?vue&type=script&lang=js"
export * from "./DeleteServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16efcba6",
  null
  
)

export default component.exports